((app) => {

    app.run(($transitions, $location, $window) => {
        $window.ga("create", "UA-111688246-1", "auto");

        $transitions.onSuccess({},
            () => { 
                $window.ga("set", "page", $location.path());
                $window.ga("send", "pageview");
            });
    });

})(window.app);